import { createAction } from "redux-actions";

import scrollTop from "../../../shared/scroll_to_top_of_page";

export const FOCUS_VIEW_OVERVIEW = "overview";
export const FOCUS_VIEW_REGULATION_DETAIL = "regulationDetail";
export const FOCUS_VIEW_TYPES = [FOCUS_VIEW_OVERVIEW, FOCUS_VIEW_REGULATION_DETAIL];

export const SWITCH_TO_REGULATION_DETAIL = "SWITCH_TO_REGULATION_DETAIL";
export const switchToRegulationDetail = createAction(SWITCH_TO_REGULATION_DETAIL);
export const regulationDetailClick = dispatch => regulations => () => {
  scrollTop();
  dispatch(switchToRegulationDetail({ regulations, focusViewType: FOCUS_VIEW_REGULATION_DETAIL }));
};

export const BREADCRUMBS_CLICK_OVERVIEW = "BREADCRUMBS_CLICK_OVERVIEW";
export const breadcrumbsClickOverview = createAction(BREADCRUMBS_CLICK_OVERVIEW);
export const crumbOverviewClick = dispatch => () => () => {
  scrollTop();
  dispatch(breadcrumbsClickOverview({ focusViewType: FOCUS_VIEW_OVERVIEW }));
};

export const BREADCRUMBS_CLICK_REGULATION_DETAIL = "BREADCRUMBS_CLICK_REGULATION_DETAIL";
export const breadcrumbsClickRegulationDetail = createAction(BREADCRUMBS_CLICK_REGULATION_DETAIL);
export const crumbRegulationDetailClick = () => () => () => {
  // dispatch(breadcrumbsClickRegulationDetail({ focusViewType: FOCUS_VIEW_REGULATION_DETAIL }));
};

export const REGULATION_STANDARDS_ANCHOR_ID = "associated-numerical-standards";
